import { fontFamilyHeading, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { blogDetailPublishInfoWidgetStyles as styles } from "@solveindustrial/Widgets/VerndaleBox/BlogDetail/BlogDetailPublishInfoWidget";
import { css } from "styled-components";

styles.publishInfo = {
    variant: "h2",
    forwardAs: "h2",
    css: css`
        margin-bottom: 40px;
        display: block;
        ${mediaQueriesBP.maxMD} {
            margin-bottom: 24px;
        }
    `,
};
